import React, { FC, useEffect, useState } from "react";
import { IRect } from "konva/lib/types";
import { 
    DEFAULT_LARGHEZZA_GUARNIZIONE,
    ALTEZZA_PANNELLO_PORTA_CLASSIC} from "../../../../../../../core/common_constants";
import { Circle, Group, Label, Line, Rect, Tag, Text } from "react-konva";
import { degree, toDrawUnit, VectorToPointsArray } from "../../../../../../../core/common_functions";
import { Vector } from "vecti";
import { useStoreSelector } from "../../../../../../../../hooks/StoreHooks";
import { InstallationType, ModelType, NullableString, OpeningDirection } from "../../../../../../../core/common_types";
import { Option } from "../../../../../../../models/door_configuration";
import { DatiPannello } from "../../../../../../../core/common_draw_types";
import { useFinishes } from "../../../../../../../providers/finish_provider";
import { getStrokeColor } from "../draw_utils";

const SPESSORE_TELAIO_EXT_PORTINA_LAT: number = 5;
const SPESSORE_TELAIO_INT_PORTINA_LAT: number = 2.5;

export const PortinaLateraleClassic: FC<{
    lpdraw: number, 
    hpdraw: number, 
    modello: Option, 
    doorColor: HTMLImageElement|undefined,
    frameColor: HTMLImageElement|undefined,
    handleColor: HTMLImageElement|undefined}> = (props) => {
    const {lpdraw, hpdraw, modello, doorColor, frameColor, handleColor} = props;
    const {doorConfigurationBuilder} = useStoreSelector(store => store);
    const strokeColor = getStrokeColor(doorConfigurationBuilder.getExternalColorCode());

    const buildPannelli = (): DatiPannello[] => {
        let isInLuce = doorConfigurationBuilder.configuration?.portinaAffiancata?.tipoInstallazione == InstallationType.in_luce;
        let spessoreTelaio = isInLuce ? SPESSORE_TELAIO_EXT_PORTINA_LAT : 0;
        let altezzaDisegno: number = 0;        
        let altezzaAssoluta = hpdraw - spessoreTelaio;
        let larghezzaDisegno: number = 0;
        let altezzaPannelloDisegno: number = 0;
        let ptBottomLeft = Vector.of([lpdraw - (2 * spessoreTelaio), hpdraw-SPESSORE_TELAIO_INT_PORTINA_LAT]);
        let ptTopLeft = Vector.of([SPESSORE_TELAIO_INT_PORTINA_LAT, altezzaAssoluta]);
        let ptTopRight = Vector.of([lpdraw - (2 * spessoreTelaio) - SPESSORE_TELAIO_INT_PORTINA_LAT, altezzaAssoluta]);
        let larghezzaAssoluta = ptTopRight.x - ptTopLeft.x;

        altezzaDisegno = altezzaAssoluta - (2 * SPESSORE_TELAIO_INT_PORTINA_LAT);
        larghezzaDisegno = larghezzaAssoluta;
        altezzaPannelloDisegno = ALTEZZA_PANNELLO_PORTA_CLASSIC;

        let y: number = ptBottomLeft.y;
        let altezzaCorrenteDisegno: number = 0;
        let panelNumber = 1;
        let panelCount: number = 0;

        let panels: DatiPannello[] = [];
        while (altezzaCorrenteDisegno < altezzaDisegno) {
            let height = altezzaPannelloDisegno;
            let altezzaAssolutaPannello = ALTEZZA_PANNELLO_PORTA_CLASSIC;

            if ((altezzaCorrenteDisegno + altezzaPannelloDisegno) > altezzaDisegno) {
                height = altezzaDisegno - altezzaCorrenteDisegno;
                altezzaAssolutaPannello = altezzaAssoluta - ((panelNumber-1) * ALTEZZA_PANNELLO_PORTA_CLASSIC);
            }

            let p: DatiPannello = { 
                bbox: {x: ptTopLeft.x + spessoreTelaio, y: y - height, width: larghezzaDisegno, height},
                panelNumber,
                panelCount,
                larghezzaAssoluta,
                altezzaAssoluta: altezzaAssolutaPannello,
                altezzaRelativa: altezzaPannelloDisegno,
                selectable: true,
            };

            panels.push(p);

            altezzaCorrenteDisegno += height;
            y -= height;
            panelNumber++;
        }

        panelCount = panels.length;
        panels.forEach(p => p.panelCount = panelCount);
        
        return panels;
    }

    const renderPorta = () => {
        if (doorConfigurationBuilder.configuration?.portinaAffiancata?.tipoInstallazione == InstallationType.in_luce) {
            return (
                <Group>
                    <Rect
                        x={SPESSORE_TELAIO_EXT_PORTINA_LAT}
                        y={SPESSORE_TELAIO_EXT_PORTINA_LAT}
                        width={lpdraw - (2 * SPESSORE_TELAIO_EXT_PORTINA_LAT)}
                        height={hpdraw - (SPESSORE_TELAIO_EXT_PORTINA_LAT)}
                        stroke={strokeColor} 
                        strokeWidth={1}
                        fillPatternImage={doorColor}
                    />
                    <Line
                        points={[
                            SPESSORE_TELAIO_EXT_PORTINA_LAT+SPESSORE_TELAIO_INT_PORTINA_LAT,
                            SPESSORE_TELAIO_EXT_PORTINA_LAT+SPESSORE_TELAIO_INT_PORTINA_LAT,
                            lpdraw-SPESSORE_TELAIO_EXT_PORTINA_LAT-SPESSORE_TELAIO_INT_PORTINA_LAT,
                            SPESSORE_TELAIO_EXT_PORTINA_LAT+SPESSORE_TELAIO_INT_PORTINA_LAT,
                            lpdraw-SPESSORE_TELAIO_EXT_PORTINA_LAT-SPESSORE_TELAIO_INT_PORTINA_LAT,
                            hpdraw-SPESSORE_TELAIO_INT_PORTINA_LAT,
                            SPESSORE_TELAIO_EXT_PORTINA_LAT+SPESSORE_TELAIO_INT_PORTINA_LAT,
                            hpdraw-SPESSORE_TELAIO_INT_PORTINA_LAT,
                        ]}
                        stroke={strokeColor} 
                        strokeWidth={1}
                        closed
                    />
                </Group>
            );
        } else {
            return (
                <Group>
                    <Rect
                        x={0}
                        y={0}
                        width={lpdraw}
                        height={hpdraw}
                        stroke={strokeColor} 
                        strokeWidth={1}
                        fillPatternImage={doorColor}
                    />
                    <Line
                        points={[
                            SPESSORE_TELAIO_INT_PORTINA_LAT,
                            SPESSORE_TELAIO_INT_PORTINA_LAT,
                            lpdraw-SPESSORE_TELAIO_INT_PORTINA_LAT,
                            SPESSORE_TELAIO_INT_PORTINA_LAT,
                            lpdraw-SPESSORE_TELAIO_INT_PORTINA_LAT,
                            hpdraw-SPESSORE_TELAIO_INT_PORTINA_LAT,
                            SPESSORE_TELAIO_INT_PORTINA_LAT,
                            hpdraw-SPESSORE_TELAIO_INT_PORTINA_LAT,
                        ]}
                        stroke={strokeColor} 
                        strokeWidth={1}
                        closed
                    />
                </Group>
            );
        }
    }

    const renderPanels = () => {
        let pannelli = buildPannelli();
        
        return pannelli.map((p, idx, ar) => (
            <PannelloPortaClassic
                key={`panel_${(idx+1)}`}
                lp={lpdraw}
                hp={hpdraw}
                panelData={p}
                doorColor={doorColor}
                modello={modello}
            />
        ));
    }

    const renderTelaio = () => {
        if (!(doorConfigurationBuilder.configuration?.portinaAffiancata?.portina || false)) return null;

        const altezzaPortina = toDrawUnit(doorConfigurationBuilder.configuration.portinaAffiancata.altezza);
        const larghezzaPortina = toDrawUnit(doorConfigurationBuilder.configuration.portinaAffiancata.larghezza);

        return <TelaioPortinaLaterale
            org={Vector.of([larghezzaPortina/2, altezzaPortina])}
            altezzaPortina={altezzaPortina}
            larghezzaPortina={larghezzaPortina}
            spessoreTelaio={SPESSORE_TELAIO_EXT_PORTINA_LAT}
            frameColor={frameColor}
            colorCode={doorConfigurationBuilder.getExternalColorCode()}
        />
    }

    const renderLabelCampione = () => {
        let pt1: Vector = Vector.of([0, hpdraw]);
        let pt2: Vector = Vector.of([lpdraw, 0]);
        let rads = degree(pt1.x, pt1.y, pt2.x, pt2.y);
        return (
            <Label x={(lpdraw/2)-75} y={(hpdraw/2)+40} rotation={rads} opacity={0.6}>
                <Tag fill="white" stroke="red"/>
                <Text text={"Colore da campione"} padding={5} fontSize={20} />
            </Label>
        );
    }

    const renderManiglia = () => {
        if (!(doorConfigurationBuilder.configuration?.portinaAffiancata?.portina || false)) return null;

        const altezzaPortina = toDrawUnit(doorConfigurationBuilder.configuration.portinaAffiancata.altezza);
        let larghezzaPortina = toDrawUnit(doorConfigurationBuilder.configuration.portinaAffiancata.larghezza);
        let sp = 0;
        
        if (doorConfigurationBuilder.configuration?.portinaAffiancata?.tipoInstallazione == InstallationType.in_luce) {
            larghezzaPortina -= 2 * SPESSORE_TELAIO_EXT_PORTINA_LAT;
            sp = SPESSORE_TELAIO_EXT_PORTINA_LAT;
        }
        
        return <Maniglia
            org={Vector.of([(larghezzaPortina/2)+sp, altezzaPortina])}
            altezzaPortina={altezzaPortina}
            larghezzaPortina={larghezzaPortina}
            pos={doorConfigurationBuilder.configuration?.portinaAffiancata?.versoApertura ?? "sx"}
            externalHandleColor={handleColor}
            colorCode={doorConfigurationBuilder.getExternalColorCode()}
        />
    }

    if (!doorConfigurationBuilder.configuration) return null;
    if (!doorConfigurationBuilder.configuration.porta) return null;
    if (!doorConfigurationBuilder.configuration.modello) return null;

    return (
        <Group>
            {doorConfigurationBuilder.configuration?.portinaAffiancata?.tipoInstallazione == InstallationType.in_luce && renderTelaio()}
            {renderPorta()}
            {renderPanels()}
            {renderManiglia()}

            {doorConfigurationBuilder.configuration.tipoColoreEsterno == "a_campione" && renderLabelCampione()}
        </Group>
    );
}

const PannelloPortaClassic: FC<{lp: number, hp: number, modello: Option, doorColor: HTMLImageElement|undefined, panelData: DatiPannello}> = (props) => {
    const {doorConfigurationBuilder} = useStoreSelector(store => store);
    const strokeColor = getStrokeColor(doorConfigurationBuilder.getExternalColorCode());
    const delta = toDrawUnit(30/2);

    const addFinituraWide = () => {
        let ptTopLeft = Vector.of([props.panelData.bbox.x, props.panelData.bbox.y + props.panelData.bbox.height + delta]);
        let ptTopRight = Vector.of([props.panelData.bbox.x + props.panelData.bbox.width, props.panelData.bbox.y + props.panelData.bbox.height + delta]);
        let ptBottomLeft = Vector.of([props.panelData.bbox.x, props.panelData.bbox.y + props.panelData.bbox.height - delta]);
        let ptBottomRight = Vector.of([props.panelData.bbox.x + props.panelData.bbox.width, props.panelData.bbox.y + props.panelData.bbox.height - delta]);
        let ptCenterLeft = Vector.of([props.panelData.bbox.x, props.panelData.bbox.y + props.panelData.bbox.height - (props.panelData.altezzaRelativa/2)]);
        let ptCenterRight = Vector.of([props.panelData.bbox.x + props.panelData.bbox.width, props.panelData.bbox.y + props.panelData.bbox.height - (props.panelData.altezzaRelativa/2)]);

        return (
            <Group>
                {props.panelData.panelNumber == 1 && <Line 
                    points={[ptTopLeft.x, props.panelData.bbox.y + props.panelData.bbox.height, ptTopRight.x, props.panelData.bbox.y + props.panelData.bbox.height]}
                    stroke={strokeColor}
                    strokeWidth={0.5}
                />}
                {props.panelData.panelNumber > 1 && <Line 
                    points={[ptTopLeft.x, ptTopLeft.y, ptTopRight.x, ptTopRight.y]}
                    stroke={strokeColor}
                    strokeWidth={0.5}
                />}
                {/*props.panelData.panelNumber != props.panelData.panelCount &&*/ <Line 
                    points={[ptCenterLeft.x, ptCenterLeft.y - delta, ptCenterRight.x, ptCenterRight.y - delta]}
                    stroke={strokeColor}
                    strokeWidth={0.5}                    
                />}
                {/*props.panelData.panelNumber != props.panelData.panelCount &&*/ <Line 
                    points={[ptCenterLeft.x, ptCenterLeft.y + delta, ptCenterRight.x, ptCenterRight.y + delta]}
                    stroke={strokeColor}
                    strokeWidth={0.5}
                />}
                <Line 
                    points={[ptBottomLeft.x, ptBottomLeft.y, ptBottomRight.x, ptBottomRight.y]}
                    stroke={strokeColor}
                    strokeWidth={0.5}
                />
            </Group>
        );
    }

    const getBboxDisegno = (panelData: DatiPannello): IRect => {       
        let org = Vector.of([panelData.bbox.x, panelData.bbox.y]);
        let larghezza = panelData.bbox.width;
        let altezza = panelData.bbox.height;

        if (doorConfigurationBuilder.isOltreLuce()) {  
            panelData.debugPt = [];
        }

        let rect: IRect =  {
            ...org,
            width: larghezza,
            height: altezza
        };

        panelData.org = {x: org.x, y: org.y};
        
        return rect;
    }

    return (
        <Group>
            <Rect 
                {...getBboxDisegno(props.panelData)}
                stroke={strokeColor} 
                strokeWidth={0.5}
                strokeEnabled={props.modello?.name != ModelType.wide}
                fillPatternImage={props.doorColor ? props.doorColor : undefined}
            />

            {props.modello?.name == ModelType.wide && addFinituraWide()}

            {/* <Circle
                x={props.panelData.org?.x}
                y={props.panelData.org?.y}
                radius={4}
                fill={"green"}
            /> */}

            {/*props.panelData.debugPt?.map(p => (
                <Circle
                    x={p.x}
                    y={p.y}
                    radius={4}
                    fill={"blue"}
                />  
            ))*/}
        </Group>
    );
}

const TelaioPortinaLaterale: FC<{ org: Vector, altezzaPortina: number, larghezzaPortina: number, spessoreTelaio: number, frameColor: HTMLImageElement|undefined, colorCode?: NullableString }> = (props) => {
    const { org, altezzaPortina, larghezzaPortina, spessoreTelaio, frameColor } = props;
    const strokeColor = getStrokeColor(props.colorCode);

    const getPointsTelaioSx = (): Vector[] => {
        let ptBottomLeft = Vector.of([org.x - (larghezzaPortina / 2), org.y]);
        let ptTopLeft = Vector.of([ptBottomLeft.x, org.y - altezzaPortina]);
        let ptTopRight = Vector.of([ptBottomLeft.x + spessoreTelaio, ptTopLeft.y + SPESSORE_TELAIO_EXT_PORTINA_LAT]);
        let ptBottomRight = Vector.of([ptTopRight.x, org.y]);

        return [
            ptBottomLeft,
            ptTopLeft,
            ptTopRight,
            ptBottomRight
        ];
    }

    const getPointsTelaioDx = (): Vector[] => {
        let ptTopRight = Vector.of([org.x + (larghezzaPortina / 2), org.y - altezzaPortina]);
        let ptBottomRight = Vector.of([ptTopRight.x, org.y]);
        let ptBottomLeft = Vector.of([ptBottomRight.x - spessoreTelaio, org.y]);
        let ptTopLeft = Vector.of([ptBottomLeft.x, ptTopRight.y + SPESSORE_TELAIO_EXT_PORTINA_LAT]);

        return [
            ptBottomLeft,
            ptTopLeft,
            ptTopRight,
            ptBottomRight
        ];
    }

    const getPointsTelaioSup = (): Vector[] => {
        let ptTopLeft = Vector.of([org.x - (larghezzaPortina / 2), org.y-altezzaPortina]);
        let ptTopRight = Vector.of([ptTopLeft.x + larghezzaPortina, ptTopLeft.y]);
        let ptBottomRight = Vector.of([ptTopRight.x - spessoreTelaio, ptTopLeft.y + spessoreTelaio]);
        let ptBottomLeft = Vector.of([ptTopLeft.x + spessoreTelaio, ptBottomRight.y]);

        return [
            ptBottomLeft,
            ptTopLeft,
            ptTopRight,
            ptBottomRight
        ];
    }

    return (
        <Group>
            <Line
                points={VectorToPointsArray(getPointsTelaioSx())}
                stroke={strokeColor}
                strokeWidth={0.5}
                fillPatternImage={frameColor}
                closed
            />
            <Line
                points={VectorToPointsArray(getPointsTelaioDx())}
                stroke={strokeColor}
                strokeWidth={0.5}
                fillPatternImage={frameColor}
                closed
            />
            <Line
                points={VectorToPointsArray(getPointsTelaioSup())}
                stroke={strokeColor}
                strokeWidth={0.5}
                fillPatternImage={frameColor}
                closed
            />
        </Group>
    );
}

const Maniglia: FC<{ org: Vector, larghezzaPortina: number, altezzaPortina: number, pos: OpeningDirection, externalHandleColor: HTMLImageElement|undefined, colorCode?: NullableString }> = (props) => {
    const { org, larghezzaPortina, altezzaPortina, pos, externalHandleColor } = props;
    const strokeColor = getStrokeColor(props.colorCode);

    const getPosManiglia = (): Vector => {
        if (pos == "dx") return Vector.of([
            org.x - (larghezzaPortina/2) + (SPESSORE_TELAIO_EXT_PORTINA_LAT + SPESSORE_TELAIO_INT_PORTINA_LAT + 5),
            org.y - (altezzaPortina/2)
        ])

        return Vector.of([
            org.x + (larghezzaPortina/2) - SPESSORE_TELAIO_INT_PORTINA_LAT - 12 - 10,
            org.y - (altezzaPortina/2)
        ]);
    }

    const getPosCopriManiglia = (): Vector => {
        if (pos == "dx") return Vector.of([
            org.x - (larghezzaPortina/2) + (SPESSORE_TELAIO_EXT_PORTINA_LAT + SPESSORE_TELAIO_INT_PORTINA_LAT + 5) - 1,
            org.y - (altezzaPortina/2) - 1.7
        ]);

        return Vector.of([
            org.x + (larghezzaPortina/2) - SPESSORE_TELAIO_INT_PORTINA_LAT - 10 - 1.25,
            org.y - (altezzaPortina/2) - 1.5
        ]);
    }

    const getPosCilindro = (): Vector => {
        if (pos == "dx") return Vector.of([
            org.x - (larghezzaPortina/2) + (SPESSORE_TELAIO_EXT_PORTINA_LAT + SPESSORE_TELAIO_INT_PORTINA_LAT + 5),
            org.y - (altezzaPortina/2) + 8
        ]);

        return Vector.of([
            org.x + (larghezzaPortina/2) - SPESSORE_TELAIO_INT_PORTINA_LAT - 10,
            org.y - (altezzaPortina/2) + 8
        ]);
    }

    return (
        <Group>
            <Rect
                {...getPosCopriManiglia()}
                width={2.5}
                height={5}
                fill={externalHandleColor == undefined ? "#000" : undefined}
                fillPatternImage={externalHandleColor != undefined ? externalHandleColor : undefined }
                cornerRadius={1}
                stroke={strokeColor}
                strokeWidth={0.25}
            />
            <Rect
                {...getPosManiglia()}
                width={12}
                height={2}
                fill={externalHandleColor == undefined ? "#000" : undefined}
                fillPatternImage={externalHandleColor != undefined ? externalHandleColor : undefined }
                cornerRadius={0.5}
                stroke={strokeColor}
                strokeWidth={0.25}
            />
            <Circle
                {...getPosCilindro()}
                radius={1.5}
                fill={externalHandleColor == undefined ? "#000" : undefined}
                fillPatternImage={externalHandleColor != undefined ? externalHandleColor : undefined }
                stroke={strokeColor}
                strokeWidth={0.25}
            />
            <Circle
                {...getPosCilindro()}
                radius={0.75}
                fill={externalHandleColor == undefined ? "#000" : undefined}
                fillPatternImage={externalHandleColor != undefined ? externalHandleColor : undefined }
                stroke={strokeColor}
                strokeWidth={0.25}
            />
        </Group>
    );
}